import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
import VeltCommentDialogSuggestionMenuTriggerWireframe from './VeltCommentDialogSuggestionMenuTriggerWireframe/VeltCommentDialogSuggestionMenuTriggerWireframe';
import VeltCommentDialogSuggestionMenuContentWireframe from './VeltCommentDialogSuggestionMenuContentWireframe/VeltCommentDialogSuggestionMenuContentWireframe';
var VeltCommentDialogSuggestionMenuWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-suggestion-menu-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogSuggestionMenuWireframe.Trigger = VeltCommentDialogSuggestionMenuTriggerWireframe;
VeltCommentDialogSuggestionMenuWireframe.Content = VeltCommentDialogSuggestionMenuContentWireframe;
export default VeltCommentDialogSuggestionMenuWireframe;
